var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapBallon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.139,
    height: 82.139,
    viewBox: "0 0 82.139 82.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.838,
    y1: 0.135,
    x2: 0.041,
    y2: 1.21,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31beef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f4fd1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_15334",
    x: 0,
    y: 0,
    width: 82.139,
    height: 82.139,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_461",
    "data-name": "Ellipse 461",
    cx: 23.075,
    cy: 23.075,
    rx: 23.075,
    ry: 23.075,
    transform: "translate(9.09 9.09)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_15334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15334-2",
    "data-name": "Path 15334",
    d: "M62.215,30.145H57.926A25.978,25.978,0,0,0,33.974,6.19V1.924a1.924,1.924,0,1,0-3.848,0V6.19A25.978,25.978,0,0,0,6.173,30.145H1.924a1.924,1.924,0,1,0,0,3.848H6.173A25.978,25.978,0,0,0,30.125,57.948v4.267a1.924,1.924,0,1,0,3.848,0V57.948A25.977,25.977,0,0,0,57.926,33.993h4.289a1.924,1.924,0,1,0,0-3.848ZM32.049,54.2A22.127,22.127,0,1,1,54.178,32.069,22.127,22.127,0,0,1,32.049,54.2Zm0,0",
    transform: "translate(9 6)",
    fill: "#0e4fd1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "air-balloon",
    transform: "translate(19.579 16.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15329",
    "data-name": "Path 15329",
    d: "M127.666,20.307l1.726,4.443h2.446l1.726-4.443a23.023,23.023,0,0,0,1.267-7.932,25.987,25.987,0,0,0-1.453-9.085C132.579,1.23,131.545,0,130.615,0s-1.963,1.23-2.764,3.291a25.986,25.986,0,0,0-1.453,9.084A23.023,23.023,0,0,0,127.666,20.307Zm0,0",
    transform: "translate(-118.24)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15330",
    "data-name": "Path 15330",
    d: "M243.113,8.051a12.185,12.185,0,0,1,1.019,2.07,27.942,27.942,0,0,1,1.584,9.786,24.652,24.652,0,0,1-1.4,8.633l-1.454,3.742h.848A.968.968,0,0,0,244.4,32l4.326-4.326a10.911,10.911,0,0,0,3.216-7.765A12.4,12.4,0,0,0,243.113,8.051Zm0,0",
    transform: "translate(-227.188 -7.531)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15331",
    "data-name": "Path 15331",
    d: "M9.075,32.281,7.62,28.539a24.652,24.652,0,0,1-1.4-8.633A27.942,27.942,0,0,1,7.806,10.12a12.186,12.186,0,0,1,1.02-2.07A12.4,12.4,0,0,0,0,19.906a10.911,10.911,0,0,0,3.216,7.765L7.542,32a.968.968,0,0,0,.684.284Zm0,0",
    transform: "translate(0 -7.531)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15332",
    "data-name": "Path 15332",
    d: "M129.47,415.611H124.4V413.4h-1.693q-.123,0-.243,0v5.4a.968.968,0,0,0,.968.968h7.005a.968.968,0,0,0,.968-.968V413.4H129.47Zm0,0",
    transform: "translate(-114.561 -386.713)",
    fill: "#fafafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBallon);
export default __webpack_public_path__ + "static/media/map-ballon.4572c3db005aa44907cf9e12ee41074f.svg";
export { ForwardRef as ReactComponent };